/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_PURCHASE_RECORDS_META_DATA,
  LOAD_PURCHASE,
  CREATE_PURCHASE,
  UPDATE_PURCHASE,
  DELETE_PURCHASE,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PURCHASE_PARTIES_CATEGORY,
  CREATE_PURCHASE_PARTIES_CATEGORY,
  LOAD_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS,
  LOAD_DASHBOARD_TRANSACTION,
  LOAD_TOTAL_BALANCE,
} from "./constants";

import {
  loadPurchaseOrders,
  loadPurchaseOrdersSuccess,
  loadPurchaseOrdersError,
  createPurchaseListSuccess,
  createPurchaseListError,
  updatePurchaseListSuccess,
  updatePurchaseListError,
  deletePurchaseListSuccess,
  deletePurchaseListError,
  loadPurchaseRecordsMetaDataError,
  loadPurchaseRecordsMetaDataSuccess,
  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,
  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,
  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,
  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,
  loadTotalBalance,
  loadTotalBalanceSuccess,
  loadTotalBalanceError,
} from "./actions";

import {
  loadPartiesDetails,
  createPartiesDetails,
  updatePartiesDetails,
  deletePartiesDetails,
  loadRecordsMetaData,
  loadPartiesTransactionDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadDashboardTransactionsDetails,
  loadTotalBalanceDetails,
} from "./remotes";

function* loadPurchaseSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadPurchaseOrders(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesDetails, partiesList);

        if (result) {
          yield put(loadPurchaseOrdersSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPurchaseOrdersError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardTransactionsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DASHBOARD_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadDashboardTransactions(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadDashboardTransactionsDetails,
          transactionsList
        );

        if (result) {
          yield put(loadDashboardTransactionsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDashboardTransactionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTotalBalanceDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TOTAL_BALANCE),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalBalance(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalBalanceDetails, transactionsList);

        if (result) {
          yield put(loadTotalBalanceSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTotalBalanceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyVendorAddressSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTY_VENDOR_ADDRESS),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadPartyVendorAddress(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartyVendorAddressDetails, partiesList);

        if (result) {
          yield put(loadPartyVendorAddressSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartyVendorAddressSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PARTY_VENDOR_ADDRESS),
    });

    const { partyAddress } = create || {};

    if (create) {
      try {
        const result = yield call(
          createPartyVendorAddressDetails,
          partyAddress
        );
        if (result) {
          yield put(createPartyVendorAddressSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadPartiesTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesTransactionDetails, partiesList);

        if (result) {
          yield put(loadPartiesTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE),
    });

    const { partiesList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesDetails, partiesList);
        if (result) {
          yield put(createPurchaseListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPurchaseListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePartiesSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PURCHASE),
    });
    const { partiesList } = update || {};

    if (update) {
      try {
        const result = yield call(updatePartiesDetails, partiesList);
        if (result) {
          yield put(updatePurchaseListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePurchaseListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PURCHASE),
    });
    const { partiesList } = create || {};

    if (create) {
      try {
        const result = yield call(deletePartiesDetails, partiesList);
        if (result) {
          yield put(deletePurchaseListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePurchaseListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_PARTIES_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadPartiesCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesCategoryDetails, categoryList);

        if (result) {
          yield put(loadPartiesCategorySuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE_PARTIES_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesCategoryDetails, categoryList);
        if (result) {
          yield put(createPartiesCategoryListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartiesCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadItemRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PURCHASE_RECORDS_META_DATA),
    });

    try {
      const gstPercentage = yield call(loadRecordsMetaData, "getgst", "post");
      const state = yield call(loadRecordsMetaData, "getstate", "post");
      // const currency = yield call(loadRecordsMetaData, "getcurrency", "post");

      let recordsMetaData = {
        gstPercentageOptions:
          (gstPercentage &&
            gstPercentage &&
            gstPercentage.length > 0 &&
            gstPercentage.map((c) =>
              Object.assign(
                {},
                {
                  label: c.gstpercentageName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        // currencyOptions:
        //   (currency &&
        //     currency &&
        //     currency.length > 0 &&
        //     currency.map((c) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: c.currencyName,
        //           shortCode: c.shortCode,
        //           value: c._id,
        //         }
        //       )
        //     )) ||
        //   [],
      };

      yield put(loadPurchaseRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPurchaseRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPurchaseSaga(),
    deletePartiesSaga(),
    updatePartiesSaga(),
    createPartiesSaga(),
    loadItemRecordsMetaDataSaga(),
    loadPartiesTransactionSaga(),
    createPartiesCategorySaga(),
    createPartyVendorAddressSaga(),
    loadPartyVendorAddressSaga(),
    loadPartiesCategorySaga(),
    loadDashboardTransactionsSaga(),
    loadTotalBalanceDetailsSaga(),
  ]);
}
